export enum AIGenerationQueueType {
    GenerateMetaData = 0,
    CounterPartESG = 1
}
